import Search from "@/pages/search";
import CollectionPage from "@/shared-components/home/collection-page";

const SearchRoutes = [
  { path: "/search", element: <Search /> },

  /** Theme categories */
  { path: "/search/:search_type/:search_item", element: <CollectionPage collectionEndpoint="/search/artwork" /> },
];

export default SearchRoutes;